Vue.component('ppcarto-card', {
  props: ['item','settings','section'],
  data () {
    return {
    };
  },
  template: `<div class="ppcarto-card" v-on:mouseenter.stop="highlight">
    <div class="image-wrapper">
      <div class="image" v-if="item.image" v-bind:style="{backgroundImage: 'url('+item.image+')'}"></div>
    </div>
    <div class="info">
      <h5>{{item.name}}</h5>
    </div>
    <span class="loc">{{item.town}}</span>
    <div class="actions">
      <a v-bind:href='item.link' v-if="item.link" target="_blank" class="details">Details</a>
      <a href="#" class="route" @click="trip">Anreise</a>
    </div>
  </div>`,
  computed: {
    image (){
      return "";
      let url = "";
      if(this.item.image) {
        url = `${this.settings.api.baseurl}asset/${this.item.image.id}/thumbnail?w=352&h=220`
      } else {
        url = `${this.settings.api.baseurl}poi/${this.item.id}/placeholder`
      }
      return this.item.image;
    }
  },
  methods: {
    highlight(){
      this.$store.commit("setHighlight", {id: this.item.id, section: this.section.key })
    },
    trip(){
      let action = _.find(this.$store.getters.getActions, a => a.key == 'rome2rio');
      let rome2rio = this.$store.getters.getRome2Rio;
      let destination = {
        longName: `${this.item.name}, ${this.item.town}`,
        lat: this.item.coordinates[1],
        lng: this.item.coordinates[0]
      }
      this.$store.commit('setRome2Rio', {
        origin: rome2rio.origin || null,
        destination: destination || null,
        from: rome2rio.origin.longName || null,
        to: destination.longName || null,
        visible: true
      })

      if(this.$store.getters.showMap) this.$store.commit('toggleMap');

      if(!action.selected) {
        this.$store.commit('toggleAction', action);
      }
    }
  }
});
